import { plainCompoundVariants, plainDefaultVariants, plainDisabledVariants, plainEmphasisVariants, plainTextStyleVariants, plainTypeVariants, plainVariantSlots } from "../../variants/index.js";
import { tv } from "../../variants/tv.js";
const plainButtonVariants = tv({
    slots: plainVariantSlots,
    variants: {
        type: plainTypeVariants,
        textStyle: plainTextStyleVariants,
        emphasis: plainEmphasisVariants,
        disabled: plainDisabledVariants
    },
    compoundVariants: plainCompoundVariants,
    defaultVariants: plainDefaultVariants
});
export { plainButtonVariants };
